import { EHealthProceduresTypes, IHealthProcedures, IPregnancy } from '~/interfaces'

export const INFANT_AGE = 6

interface ICreateBirthReportEvent extends IPregnancy {
  childId: number
}

export const createBirthReportEvent = (birthData: ICreateBirthReportEvent): IHealthProcedures => {
  return {
    id: String(birthData.childId),
    passage: '',
    subtypes: [],
    startDate: birthData.endDate,
    endDate: birthData.endDate,
    type: EHealthProceduresTypes.BIRTH,
    description: 'Informações do Nascimento',
    isAltered: false,
    biradsCategory: undefined
  }
}

export * from './babyGrowthPercentiles'
